module.exports = __webpack_public_path__ + "front/img/m_exhibition.1601bd29.jpg";